import React, { useState } from "react";
import { MapPin } from "react-feather";
import styled from "styled-components";
import LoaderWrapper from "../../../../components/Loaders/LoaderWrapper";
import OnLoadError from "../../../../components/UI/OnLoadError";
import { ENGAGEMENT_TYPES } from "../../../../storage/constants";
import useSupervisorHomeV2 from "../../../../swr/hooks/Home/useSupervisorHomeV2";
import EngagementTypeSelect from "../../reports/reuseableComponents/EngagementTypeSelect";
import HeroLayout from "../layouts/HeroLayout";
import HomeHeader from "../reuseableComponents/HomeHeader";
import MultipleLocationView from "./MultipleLocationView";
import SingleLocationView from "./SingleLocationView";
import SwitchLocationV2 from "./SwitchLocationV2";

const Wrapper = styled.div`
  height: calc(100vh - 64px);
  height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
`;

const FakeButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 36px;

  gap: 4px;
  padding: 5px;
  background: white;
  border-radius: 10px;
  border: 1px solid lightgray;
  min-width: 100px;

  transition: none;
`;

const REPORT_IDENTIFIERS = {
  MUTIPLE_LOCATIONS: "multi-location",
  SINGLE_LOCATION: "single-location",
};

const ManagerHome = () => {
  const [selectedLocationId, setSelectedLocationId] = useState(null);
  const [submissionsType, setSubmissionType] = useState(ENGAGEMENT_TYPES.ALL);

  const { data, isLoading, isError } = useSupervisorHomeV2(selectedLocationId);

  if (isLoading) {
    return (
      <>
        <Wrapper>
          <HeroLayout>
            <HomeHeader>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start",
                }}
              >
                <div style={{ width: 8, minWidth: 8 }} />

                <FakeButton>
                  <MapPin height={12} width={12} color="black" />
                </FakeButton>
                <div style={{ marginLeft: "auto" }} />
                <EngagementTypeSelect
                  engagementType={submissionsType}
                  setEngagementType={setSubmissionType}
                />
              </div>
            </HomeHeader>
            <LoaderWrapper text="Dashboard" />
          </HeroLayout>
        </Wrapper>
      </>
    );
  }

  if (isError) {
    return <OnLoadError />;
  }

  return (
    <Wrapper>
      <HeroLayout>
        <HomeHeader>
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
            }}
          >
            <div style={{ width: 8, minWidth: 8 }} />
            <SwitchLocationV2
              selectedLocationId={selectedLocationId}
              locationList={data?.managed_locations}
              setSelectedLocationId={setSelectedLocationId}
            />
            <div style={{ marginLeft: "auto" }} />
            <EngagementTypeSelect
              engagementType={submissionsType}
              setEngagementType={setSubmissionType}
            />
          </div>
        </HomeHeader>
        {data?.report_identifier === REPORT_IDENTIFIERS.SINGLE_LOCATION ? (
          <SingleLocationView data={data} submissionsType={submissionsType} />
        ) : (
          <MultipleLocationView data={data} submissionsType={submissionsType} />
        )}
        <div></div>
      </HeroLayout>
    </Wrapper>
  );
};

export default ManagerHome;
